import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import BasketIconComponent from './js/basket-icon.componenet';

ComponentsFactory.getInstance().define('basket-icon', BasketIconComponent);
